const setAuthToken = (api, token) => {
  api.defaults.headers.common['Authorization'] = token || '';
};

export default setAuthToken;
